import { createFileRoute } from '@tanstack/react-router'

import { OverviewPage } from '@/pages/overview/OverviewPage'

export const Route = createFileRoute('/_authenticated/_dashboard/')({
  component: OverviewPage,
})
